import { render, staticRenderFns } from "./DeclaracaoVinculoVisualizarPDF.vue?vue&type=template&id=76f6bdf8&scoped=true&"
import script from "./DeclaracaoVinculoVisualizarPDF.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoVinculoVisualizarPDF.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoVinculoVisualizarPDF.vue?vue&type=style&index=0&id=76f6bdf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f6bdf8",
  null
  
)

export default component.exports